import { useCallback } from 'react';
import { SitePhotoService } from '../../services/SitePhotoService';

/**
 * RichTextEditor 본문에 인라인으로 넣을 이미지 업로드 콜백.
 *
 * SitePhoto 로 저장(현장 사진과 동일 저장소, category='other')한 뒤, 토큰을 붙이지
 * 않은 파일 경로를 돌려준다 — 본문 마크다운에는 만료되지 않는 경로만 남고, 화면
 * 렌더 시 MediaImage 확장이 토큰을 붙인다.
 */
export function useEditorImageUpload(projectId: number): (file: File) => Promise<string> {
  return useCallback(
    async (file: File): Promise<string> => {
      const photo = await SitePhotoService.upload(projectId, { file, category: 'other' });
      return SitePhotoService.filePath(photo.id);
    },
    [projectId],
  );
}

export default useEditorImageUpload;
